/***
 * @file:
 * @author: linkun.he
 * @Date: 2020-08-31 17:38:04
 */
import { Injectable } from '@angular/core';
import { SettingsService } from './setting.service';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  private isMultiTenantMode: boolean;
  private tenantId;
  constructor(private settingsSrv: SettingsService) {
    this.isMultiTenantMode = this.settingsSrv.userConfig['pages'].multiTenantMode;
    this.tenantId = this.settingsSrv.user.tenantId;
  }

  // æ¯å¦ä¸ºç§æ·æ¨¡å¼
  get multiTenantMode(): boolean {
    return this.isMultiTenantMode || false;
  }

  // æ¯å¦ä¸ºå¹³å°ç®¡çåï¼ï¼0 ä»£è¡¨ç®¡çå
  get isPlatformAdmin(): boolean {
    return this.multiTenantMode && this.tenantId === '0';
  }
}
